import { useInjection } from "@linkfluence/core/di";
import { useMutation } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useInvalidRecurringSnapshots() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { mutateAsync, isLoading, isError, isSuccess, data } = useMutation(
    ({
      project,
      id,
      timezone,
    }: {
      project: number;
      id: InsightPage["id"];
      timezone: InsightPage["timezone"];
    }) => {
      return repository.getInvalidRecurringSnapshots(project, id, timezone);
    }
  );
  const getInvalidRecurringSnapshots = (data: {
    project: number;
    id: InsightPage["id"];
    timezone: InsightPage["timezone"];
  }) => {
    return mutateAsync(data);
  };
  return {
    getInvalidRecurringSnapshots,
    loading: isLoading,
    error: isError,
    success: isSuccess,
    recurringSnapshots: data,
  };
}
